import { Vector3 } from "three";

import { ControllerStrategy } from "../strategy";

/**
 * Simple collision class to ensure camera doesn't clip through ground plane.
 */
export class GroundCollisionControllerStrategy extends ControllerStrategy {
  groundLevel = 2;
  pos = new Vector3();
  offset = new Vector3();
  target = new Vector3();

  prevPos = 0;
  prevOffset = 0;

  update(_deltaS: number, _gameTimeDelta: number, _frameNum?: number) {
    const controls = this.registered?.controls;

    if (controls) {
      controls.getPosition(this.pos);
      controls.getFocalOffset(this.offset);
      controls.getTarget(this.target);

      const delta = this.pos.y - this.offset.y - this.groundLevel;

      if (delta < 0) {
        if (this.pos.y != this.prevPos) {
          this.pos.y = this.prevPos;
          controls.setPosition(this.pos.x, this.pos.y, this.pos.z);
        }
        if (this.offset.y != this.prevOffset) {
          this.offset.y = this.prevOffset;
          controls.setFocalOffset(this.offset.x, this.offset.y, this.offset.z);
        }
      }

      this.prevPos = this.pos.y;
      this.prevOffset = this.offset.y;
    }
  }
}
